import { thunk, action } from 'easy-peasy'

import _isEmpty from 'lodash/isEmpty'

import {
  getAddressListApi,
  getRegionListApi,
  getContactPersonListApi,
  getBillingAddressListApi,
} from 'services/address'

const _states = {
  loadingAddressList: false,
  loadingContactPersonList: false,
  loadingBillingAddressList: false,
  addressList: [],
  regionList: [],
  contactPersonList: [],
  billingAddressList: [],
}

const _actions = {
  reset: action(state => {
    state.addressList = []
  }),
  setLoadingAddressList: action((state, payload) => {
    state.loadingAddressList = payload
  }),
  setLoadingContactPersonList: action((state, payload) => {
    state.loadingContactPersonList = payload
  }),
  setLoadingBillingAddressList: action((state, payload) => {
    state.loadingBillingAddressList = payload
  }),
  setAddressList: action((state, payload) => {
    state.addressList = payload
  }),
  setRegionList: action((state, payload) => {
    state.regionList = payload
  }),
  setContactPersonList: action((state, payload) => {
    state.contactPersonList = payload
  }),
  setBillingAddressList: action((state, payload) => {
    state.billingAddressList = payload
  }),
}

const _thunks = {
  getAddressList: thunk(async (actions, payload, { getStoreState }) => {
    const profile = getStoreState()?.auth?.profile

    actions.setLoadingAddressList(true)

    const stakeholderId = profile?.stakeholderId

    return await getAddressListApi(stakeholderId)
      .then(res => res.data.data)
      .then(data => {
        actions.setAddressList(data)

        return data
      })
      .finally(() => {
        actions.setLoadingAddressList(false)
      })
  }),

  getContactPersonList: thunk(async (actions, payload, { getStoreState }) => {
    const profile = getStoreState()?.auth?.profile

    actions.setLoadingContactPersonList(true)

    const stakeholderId = profile?.stakeholderId

    return await getContactPersonListApi(stakeholderId)
      .then(res => res.data.data)
      .then(data => {
        actions.setContactPersonList(data)

        return data
      })
      .finally(() => {
        actions.setLoadingContactPersonList(false)
      })
  }),

  getBillingAddressList: thunk(async (actions, payload, { getStoreState }) => {
    const profile = getStoreState()?.auth?.profile

    actions.setLoadingBillingAddressList(true)

    const stakeholderId = profile?.stakeholderId

    return await getBillingAddressListApi(stakeholderId)
      .then(res => res.data.data)
      .then(data => {
        actions.setBillingAddressList(data)

        return data
      })
      .finally(() => {
        actions.setLoadingBillingAddressList(false)
      })
  }),

  getRegionList: thunk(async (actions, payload, { getState }) => {
    const regionList = getState().regionList

    if (!_isEmpty(regionList)) {
      return
    }

    await getRegionListApi()
      .then(res => res.data.data)
      .then(data => {
        actions.setRegionList(data)
      })
  }),
}

const addressModal = {
  ..._states,
  ..._actions,
  ..._thunks,
}

export default addressModal
